import React from 'react'
import TransactionDetailGroups from './transaction-detail-groups'

const Details = ({ transaction, dashboardId, onPinField, pinnedFieldIds, canEdit = true, testingData, auditReportId, initialFeatureTab }) => {
  return (
    <div className="w-100">
      <TransactionDetailGroups
        groupedDetails={transaction.grouped_transaction_details}
        allocations={transaction.allocations}
        meters={transaction.meters}
        sectionName={transaction.section_name}
        transactionId={transaction.id}
        dashboardId={dashboardId}
        onPinField={onPinField}
        pinnedFieldIds={pinnedFieldIds}
        canEdit={canEdit}
        vendor={transaction.vendor}
        remitAddress={transaction.remit_address}
        remitInvoices={transaction.remit_invoices}
        receiptScan={transaction.receipt_scan}
        testingData={testingData}
        auditReportId={auditReportId}
        initialFeatureTab={initialFeatureTab}
      />
    </div>
  )
}

export default Details
